import { Col, Row } from "reactstrap";
import Widget from "src/modules/data-protection/pages/admin/dashboard/components/Widget";

const PositiveListSummary = ({ summary }) => {
    const widgets = [
        {
            title: "Used in our organization",
            amount: summary.used,
            icon: "ri-checkbox-circle-line",
            iconColor: "#1cbb8c",
            iconSizeClass: "positive-list__widget-icon",
        },
        {
            title: "Not used in our organization",
            amount: summary.notUsed,
            icon: "ri-close-circle-line",
            iconColor: "#ff3d60",
            iconSizeClass: "positive-list__widget-icon",
        },
        {
            title: "Provided by Provider",
            titleWrap: true,
            amount: summary.toReview,
            icon: "ri-time-line",
            iconColor: "#fcb92c",
            iconSizeClass: "positive-list__widget-icon",
        },
        {
            title: "Needs a decision",
            amount: summary.pendingUserConfirmation,
            icon: "ri-question-line",
            iconColor: "#5664d2",
            iconSizeClass: "positive-list__widget-icon",
        },
    ];

    return (
        <Row className="mb-3 row-cols-1 row-cols-md-2 row-cols-lg-4">
            {widgets.map((widget) => (
                <Col className="mb-3" key={widget.title}>
                    <Widget {...widget} />
                </Col>
            ))}
        </Row>
    );
};

export default PositiveListSummary;
